import { lazy, Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';
import { STORAGE_KEY } from 'src/auth/context/auth-provider';

// ----------------------------------------------------------------------

// Auth
import LoginPage from 'src/pages/auth/login';
import RegisterPage from 'src/pages/auth/register';
import ForgotPasswordPage from 'src/pages/auth/forgot-password';
import ResetPasswordPage from 'src/pages/auth/reset-password';
import { useParams, useRouter, useSearchParams } from '../hooks';

// ----------------------------------------------------------------------

const AutoLogin = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  localStorage.setItem(STORAGE_KEY, searchParams.get("accessToken") || "");

  useEffect(() => {
    // console.log(searchParams.get("accessToken"));
    router.replace("/auth/login");
  }, [router, searchParams]);

  return <div />;
}

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: 'login',
        element: (
          <AuthClassicLayout>
            <LoginPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'auto-login',
        element: <AutoLogin />,
      },
      {
        path: 'register',
        element: (
          <AuthClassicLayout>
            <RegisterPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <AuthClassicLayout>
            <ForgotPasswordPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'reset-password',
        children: [
          {
            path: ':uuid',
            element: (
              <AuthClassicLayout>
                <ResetPasswordPage />
              </AuthClassicLayout>
            ),

          }
        ]
      }
    ],
  },
];
